<template>
    <div class="container">
    <div class="sabah">
                <button title="Close window" @click="closeWindow"> <i title="close window" style="transform: rotate(45deg);" class="fas fa-plus"></i></button>
                <h2> أذكار الصباح </h2>
                <div>
                    <p>
                        أصبحنا و أصبح الملك لله, والحمد لله, لا أإله إلا الله وحده لاشريك له, له الملك و له الحمد و هو على
                        كل شيء قدير ربي أسألك خير ما في هذا اليوم و خير ما بعده و أعوذ بك من شر ما في هذا اليوم و شر ما بعده
                        رب أعوذ بك من الكسل و سوء الكبر, رب أعوذ بك من عذاب في النار و عذاب في القبر
                    </p>
                    <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ مسلم : 2088 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        اللهم بك أصبحنا, و بك أمسينا, و بك نحيا, و بك نموت, و إليك النشور
                    </p>
                    <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ الصحيحة : 262 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        رضيت بالله ربا, و بالإسلام دينا, و بمحمد نبيا
                    </p>
                    <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ الصحيحة : 2686 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        سبحان الله و بحمده عدد خلقه, ورضا نفسه, و زنة عرشه, و مداد كلماته
                    </p>
                    <span> ثلاث مرات </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ الصحيحة : 2156 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        ما أصبحت غداة قط إلا استغفرت الله فيها مائة مرة
                    </p>
                    <span></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ الصحيحة : 1600 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        اللهم أنت ربي, لا إله إلا أنت, خلقتني و أنا عبدك, و أنا على عهدك و وعدك ما استطعت, أعوذ بك من شر ما
                        صنعت, أبوء لك بنعمتك علي, و أبوء لك بذنبي, فاغفر لي, فإنه لا يغفر الذنوب إلا أنت
                    </p>
                    <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ مختصر البخاري : 2420 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        يا حي يا قيوم برحمتك أستغيثو أصلح لي شأني كله, ولا تكلني إلى نفسي طرفة عين
                    </p>
                    <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ صحيح الترغيب : 661 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        اللهم عالم الغيب و الشهادة, فاطر السموات و الأرض, رب كل شيء و مليكه, أشهد أن لا إله إلا أنت, أعوذ بك من نفسي, و شر الشيطان و شركه, و أن أقترف على نفسي سوءا أو أجره إلى مسلم
                    </p>
                    <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ صحيح الكلم : 21 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        اللهم إني أسألك العافية في الدنيا و الآخرة, اللهم إني أسألك العفو و العافية في ديني, و دنياي, و أهلي, و مالي, اللهم استر عوراتي و آمن عوراتي, اللهم احفظني من بين يدي, و من خلفي, و عن يميني, و عن شمالي, و من فوقي, و أعوذ بعظمتك أن أغتال من تحتي
                    </p>
                    <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ صحيح الكلم : 23 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <br><br>
                <div>
                    <p>
                        لاإله إلا الله وحده لا شريك له, له الملك, و له الحمد, و هو على كل شيء قدير
                    </p>
                    <span> مرة واحدة </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ صحيح الترغيب : 656 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>                

                <br><br>
                <div>
                    <p>
                        بسم الله الذي لا يضر مع اسمه شيء, في الأرض و لا في السماء و هو السميع العليم
                    </p>
                    <span> ثلاث مرات </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span>[ صحيح الترمذي : 3388 ]</span>
                    <nav>
                        <button class="copy-class" title="Copy"><i class="fas fa-copy"></i></button>
                        <button class="post-twitter" title="Post on twitter"><i class="fab fa-twitter"></i></button>
                        <button class="share-telegram" title="Share on telegram"><i
                                class="fab fa-telegram-plane"></i></button>
                        <button class="share-wa" title="share on whatsapp"><i class="fab fa-whatsapp"></i></button>
                    </nav>
                </div>

                <!-- continue more later... -->

            </div>
            </div>
</template>


<script>
import { copyShare } from "./sharing"
import { teleShare } from "./sharing"
import { twitterShare } from "./sharing"
import { waShare } from "./sharing"
export default {

    mounted() {
        copyShare();
        teleShare();
        twitterShare();
        waShare();
    },
    methods: {
        closeWindow() {
            this.$emit("closeSabah", false);
        }
    }
}
</script>